import React, { useContext, useRef } from 'react';
import classNames from 'classnames';
import { motion } from 'framer-motion';
import ThemeContext from '../../../Contexts/themeContext';
// import Tooltips from '../../Components/bootstrap/Tooltips';
import useAsideTouch from '../../../Hooks/useAsideTouch';
import { REACT_APP_MODERN_DESGIN } from '../../../Utils/Constant';

export const AsideHead = ({ children }) => {
  return <div className="aside-head">{children}</div>;
};

export const AsideBody = ({ children }) => {
  return <div className="aside-body">{children}</div>;
};

export const AsideFoot = ({ children }) => {
  return <div className="aside-foot">{children}</div>;
};

const AsideLayout = ({ children }) => {
  const { asideStatus, mobileDesign } = useContext(ThemeContext);
  const { asideStyle, touchStatus, hasTouchButton, asideWidthWithSpace, x } = useAsideTouch();

  const isModernDesign = REACT_APP_MODERN_DESGIN == true;
  const constraintsRef = useRef(null);

  const classes = classNames(
    'aside',
    { open: asideStatus },
    {
      'aside-touch-bar': hasTouchButton && isModernDesign,
      'aside-touch-bar-close': !touchStatus && hasTouchButton && isModernDesign,
      'aside-touch-bar-open': touchStatus && hasTouchButton && isModernDesign,
    }
  );

  return (
    <>
      {mobileDesign ? (
        <aside className={classes}>{children}</aside>
      ) : (
        <motion.aside style={asideStyle} className={classes}>
          {children}
        </motion.aside>
      )}

      {asideStatus && hasTouchButton && isModernDesign && (
        <>
          <motion.div className="aside-drag-area" ref={constraintsRef} />
          {/* <Tooltips title="Toggle Aside" flip={['top', 'right']}> */}
            <motion.div
              className="aside-touch"
              drag="x"
              whileDrag={{ scale: 1.2 }}
              whileHover={{ scale: 1.1 }}
              dragConstraints={constraintsRef}
              dragElastic={0.1}
              style={{ x, zIndex: 1039 }}
              onClick={() => x.set(x.get() === 0 ? asideWidthWithSpace : 0)}
            />
          {/* </Tooltips> */}
        </>
      )}
    </>
  );
};

export default AsideLayout;
